module.exports = __webpack_public_path__ + "media/images/redes_sociales/instagram-aec0bab6d5cd4712a4a3b399d572cfcf.svg";